import { Suspense } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { lazyImport } from '@/utils/lazyImport';
import { MainLayout } from '@/components/Layout';
import { LoadingOverlay } from '@/components/Element/Loading';

const { Scan } = lazyImport(() => import('@/features/User'), 'Scan');
const { AccessError } = lazyImport(() => import('@/features/User'), 'AccessError');

const App = () => {
  return (
    <MainLayout>
      <Suspense
        fallback={<LoadingOverlay loading={true} />}
      >
        <Outlet />
      </Suspense>
    </MainLayout>
  );
};

export const publicRoutes = [

  {
    path: '/app',
    element: <App />,
    children: [
      { path: 'scan/:id', element: <Scan /> },
      { path: 'access-error/', element: <AccessError /> },
      { path: '*', element: <Navigate to="/" /> },
     
    ],
  },
];